import { jsx as t, jsxs as m } from "react/jsx-runtime";
import c from "@mui/material/Box";
import o from "@mui/material/Grid";
import n from "@mui/material/Typography";
import { makeStyles as l } from "tss-react/mui";
import { investmentCase as p } from "@lumirental/lumi-web-shared/lib/constants/IR/content";
import { useLanguageContext as d } from "@lumirental/lumi-web-shared/lib/contexts/Language.context";
import f from "../../../../../common/AccordionV2/AccordionV2.js";
import u from "./InvestmentCase.style.js";
const h = l()(u), g = () => {
  const { classes: e } = h(), { language: s } = d(), { heading: a, subtitle: r, list: i } = p;
  return /* @__PURE__ */ t(
    o,
    {
      container: !0,
      className: e.wrapper,
      justifyContent: "center",
      id: "investment-case",
      children: /* @__PURE__ */ m(o, { item: !0, xs: 12, children: [
        /* @__PURE__ */ t(
          n,
          {
            variant: "h2",
            className: e.title,
            sx: { marginBottom: 4 },
            children: a[s]
          }
        ),
        r && /* @__PURE__ */ t(
          n,
          {
            component: "div",
            variant: "body",
            className: e.subtitle,
            children: r[s]
          }
        ),
        /* @__PURE__ */ t(c, { className: e.accordionWrapper, children: /* @__PURE__ */ t(f, { language: s, dataList: i }) })
      ] })
    }
  );
}, L = g;
export {
  L as default
};
